import React, {useState, useEffect} from "react";
import {connect} from 'react-redux';
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {Container, Grid, Avatar, Box, Typography, useTheme, Drawer, Paper, MenuList, MenuItem} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import {bindActionCreators} from "redux";

import organisationActions from '../../../store/organisation/actions';
import logo from '../../../logo.svg';
import {selectUserName, selectUserOrganisation, selectUserRoles} from "../../../store/user/selectors";
import APP_URLs from "../../../consts/url";
import {IOrganisation} from "../../../common/organisation";
import { USER_ROLES } from "../../../consts/user";


type Props = {
    userName: string,
    fetchOrganisation?: Function,
    organisation?: IOrganisation,
    isSuperVisorMenu?: boolean,
    userRoles: USER_ROLES[],
}

const createAbbr = (str: String) => str.split(' ')
    .map(nameParts => nameParts[0].toUpperCase())
    .join('')

const View = ({userName, fetchOrganisation, organisation, isSuperVisorMenu, userRoles}:Props) => {
    const [name, setName] = useState<string>('');
    const [isMenuVisible, toggleMenu] = useState<boolean>(false);
    const theme = useTheme();
    //@ts-expect-error
    const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
    const {t: tranlate} = useTranslation();
    useEffect(() => {
        fetchOrganisation && fetchOrganisation();
        setName(createAbbr(userName));
    }, []);
    const MENU_ITEMS = [
        // {
        //     text: tranlate('translation:menuSettings'),
        //     url: 'javascript:void(0)',
        // },
        {
            text: tranlate('translation:menuLogout'),
            url: APP_URLs.LOGOUT,
        }
    ];
    if (userRoles.includes(USER_ROLES.SUPER) && !isSuperVisorMenu) {
        MENU_ITEMS.unshift({
            text: 'Настройки',
            url: APP_URLs.MAIN,
        })
    }
    if (isSuperVisorMenu) {
        MENU_ITEMS.unshift({
            text: 'Курсы',
            url: APP_URLs.STUDENT_PAGE,
        })
    } 
    return (
        <>
        <Box sx={{
            bgcolor: 'primary.main',
            boxShadow: 5,
            position: 'sticky',
            zIndex: 99999,
            height: '50px',
            top: 0,
            left: 0,
            maxWidth: '100%',
            overflow: 'hidden',
            px: 3,
            }}>
            <Box
                sx={{
                    gridTemplateColumns: 'auto 1fr auto',
                    gridTemplateAreas: '"logo menu avatar"',
                    display: 'grid',
                    
                }}
            >
                <Grid sx={{display: 'flex', alignItems: 'center', pr: '50px'}}>
                    <Box
                        to={APP_URLs.MAIN}
                        component={Link}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            color: '#f9f2bb',
                            textDecoration: 'none',
                            textShadow: '1px 1px 1px rgba(92, 95, 89, 1)',
                            bgcolor: 'secondary.main',
                            position: 'relative',
                            '&::before': {
                                content: '""',
                                display: 'block',
                                position: 'absolute',
                                height: '100%',
                                width: '1000px',
                                backgroundColor: 'secondary.main',
                                top: 0,
                                bottom: 0,
                                right: '100%',
                            },
                            '&::after': {
                                content: '""',
                                display: 'block',
                                position: 'absolute',
                                width: 0,
                                height: 0,
                                left: '100%',
                                borderStyle: 'solid',
                                borderWidth: '51px 0 0 51px',
                                borderColor: 'transparent',
                                borderLeftColor: 'secondary.main',
                            }
                        }}
                    >
                        <Box
                            component='img'
                            sx={{
                                width: 50,
                                display: 'block',
                            }}
                            alt={tranlate('translation:menuMain')} src={logo}
                        />
                        <Typography
                            component='h1'
                            sx={{
                                fontSize: '1.5rem',
                                display: {md: 'block', xs: 'none'},
                            }}
                        >Lift Learning</Typography>
                    </Box>
                </Grid>
                <Grid
                    item
                    sx={{
                        gridArea: 'menu',
                        px: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        pr: {xs: 2, md: '150px'},
                    }}
                >
                  <Typography
                    component={'h2'}
                    sx={{
                        color: '#fff',
                        fontSize: '1.5rem',
                        textAlign: 'center',
                        display: 'block',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        maxWidth: {xs: 'calc(100vw - 225px)', md: 'inherit'},
                    }}
                >{organisation?.name}</Typography>
                </Grid>
                <Grid item sx={{gridArea: 'avatar', display: 'flex', alignItems: 'center' }}>
                    <Avatar
                        sx={{bgcolor: 'error.main', height: 40, width: 40, cursor: 'pointer'}}
                        onClick={() => {toggleMenu(!isMenuVisible)}}
                    >
                        {name}
                    </Avatar>
                </Grid>
            </Box>
        </Box>
        {isMenuVisible && <Box sx={{ 
                    position: 'sticky',
                    zIndex: '999999',
                    top: '50px',
            }}
        >
            <Grid
                container
                sx={{
                    height: '0px',
                    justifyContent: 'flex-end',
                }}
            >
                <Paper
                    sx={{
                        width: '300px',
                        bgcolor: 'secondary.dark',
                        color: "#fff",
                        borderTopRightRadius: 0,
                        borderTopLeftRadius: 0,
                    }}
                >
                    <MenuList sx={{
                        borderTopRightRadius: 0,
                        borderTopLeftRadius: 0,
                        paddingTop: 0,
                    }}>
                        <MenuItem key={'f0'} divider={true} disabled={true} sx={{backgroundColor: 'primary.main'}}>{userName.toUpperCase()}</MenuItem>
                        {MENU_ITEMS.map((item, idx) => (
                            <MenuItem divider={idx !== MENU_ITEMS.length - 1} key={idx}>
                                <Box
                                    component={Link}
                                    to={item.url}
                                    key={item.text}
                                    sx={{
                                        color: '#fff',
                                        textDecoration: 'none',
                                    }}
                                >{item.text}</Box>
                            </MenuItem>
                        ))}
                    </MenuList>
                </Paper>
            </Grid>
        </Box>}
        </>
    )
}

//@ts-expect-error
const mapStateToProps = (state, {isSuperVisorMenu}: {isSuperVisorMenu?: boolean}) => {
    return {
        userName: selectUserName(state),
        userRoles: selectUserRoles(state),
        organisation: selectUserOrganisation(state),
        isSuperVisorMenu: isSuperVisorMenu,
    }
}

//@ts-expect-error
const dispatchProps = (dispatch) => ({
    fetchOrganisation: bindActionCreators(organisationActions.getMyOrganisation, dispatch),
})


export default connect(mapStateToProps, dispatchProps)(View);